
const whiteList = [
  '/login', // 登录页
  '/Shopindex'
//   '/register',
//   '/404'
]

export default whiteList
